import appStore from 'stores/app'

export default function buildSiteUrl(path) {
  if (!path) {
    return null
  }

  const url = new URL(`https://${appStore.site.domain}${path}`)
  url.searchParams.set('nocache', 'true')
  url.searchParams.set('force_version', 'true')

  if (process.env.NODE_ENV === 'development') {
    url.port = 3002
    url.protocol = 'http'
  }

  return url.toString()
}
